/**
 * Portal V2 is the public app.
 * /login, /steps, /dashboard, /customizeQuestions and /NonSubscriber render V2.
 * The previous screens stay available at the *_old paths.
 */

const SESSION_KEY = 'usePortalV2';

const V2_PATHS = {
    customize: '/customizeQuestions-v2',
    steps: '/steps-v2',
    dashboard: '/dashboard-v2',
    nonSubscriber: '/nonSubscriber-v2',
    login: '/login-v2',
};

const CLASSIC_PATHS = {
    customize: '/customizeQuestions_old',
    steps: '/steps_old',
    dashboard: '/dashboard_old',
    nonSubscriber: '/NonSubscriber_old',
    login: '/login_old',
};

/** Mark this browser session as Portal V2 (e.g. after /login-v2). */
export function enablePortalV2Session() {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    try {
        window.sessionStorage.setItem(SESSION_KEY, 'true');
    } catch {
        /* ignore */
    }
}

/** V2 is the live portal. The flag and session key no longer gate routes. */
export function isPortalV2Enabled() {
    return true;
}

/**
 * V2 routes always render. classicFallback is unused and kept so callers
 * do not need a signature change.
 * @returns {boolean} true when the V2 route may render
 */
export function guardPortalV2Route() {
    return true;
}

/** Always V2 routes — use inside Portal V2 screens. */
export function getPortalV2Paths() {
    return { ...V2_PATHS };
}

/** Post-login / post-step destinations. Always the V2 routes. */
export function getPortalPaths() {
    return { ...V2_PATHS };
}

/** V1 screens, kept at *_old for staff. */
export function getClassicPaths() {
    return { ...CLASSIC_PATHS };
}

export function resolveUserStepPath(userStep) {
    const paths = getPortalPaths();
    const map = {
        0: paths.customize,
        1: paths.steps,
        2: paths.steps,
        3: paths.steps,
        4: paths.dashboard,
        5: paths.dashboard,
    };
    return map[userStep] || paths.steps;
}

/** V1-only step destination (/steps_old, /dashboard_old, …). */
export function resolveUserStepPathClassic(userStep) {
    const paths = CLASSIC_PATHS;
    const map = {
        0: paths.customize,
        1: paths.steps,
        2: paths.steps,
        3: paths.steps,
        4: paths.dashboard,
        5: paths.dashboard,
    };
    return map[userStep] || paths.steps;
}

/** Resolve step destination forcing V2 routes (login-v2 / Portal V2 shell). */
export function resolveUserStepPathV2(userStep) {
    const paths = V2_PATHS;
    const map = {
        0: paths.customize,
        1: paths.steps,
        2: paths.steps,
        3: paths.steps,
        4: paths.dashboard,
        5: paths.dashboard,
    };
    return map[userStep] || paths.steps;
}

export function resolvePostOnboardingDashboard() {
    return getPortalPaths().dashboard;
}

export function resolveNonSubscriberPath() {
    return getPortalPaths().nonSubscriber;
}

export function resolveNonSubscriberPathV2() {
    return V2_PATHS.nonSubscriber;
}

export function resolveNonSubscriberPathClassic() {
    return CLASSIC_PATHS.nonSubscriber;
}
